// similar post section
document.addEventListener('DOMContentLoaded', () => {
    const postArrow = document.querySelector('.custom-blog-similar-post');
    const arrowsButton = document.querySelector('.splide__arrows--ltr')
    postArrow.addEventListener('mouseenter', function (){
    arrowsButton.classList.add('opacityone')
  });
  postArrow.addEventListener('mouseleave', function(){
    arrowsButton.classList.remove('opacityone')
  });
  })
  